import { render, staticRenderFns } from "./WkTableItems.vue?vue&type=template&id=19ea469a&scoped=true"
import script from "./WkTableItems.vue?vue&type=script&lang=js"
export * from "./WkTableItems.vue?vue&type=script&lang=js"
import style0 from "./WkTableItems.vue?vue&type=style&index=0&id=19ea469a&lang=scss"
import style1 from "./WkTableItems.vue?vue&type=style&index=1&id=19ea469a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ea469a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19ea469a')) {
      api.createRecord('19ea469a', component.options)
    } else {
      api.reload('19ea469a', component.options)
    }
    module.hot.accept("./WkTableItems.vue?vue&type=template&id=19ea469a&scoped=true", function () {
      api.rerender('19ea469a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NewCom/WkDetailTable/WkTableItems.vue"
export default component.exports